import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import {
  MultiFormWithAllRoundBorder,
  MultiFormWithBottomBorder,
  MultiFormWithImageAtTheLeft,
} from './multi-form-variants';
import {
  SingleFormWithImageAtCenter,
  SingleFormWithImageAtLeft,
  SingleFormWithImageAtRight,
} from './single-form-variants';
import { CpProjectFormsWidgetData } from './types';

export const CpProjectForms: React.FC<CpWidgetProps> = ({
  widget,
  data: _data,
  projectId,
  disabled,
}) => {
  const data = useMemo(() => _data as CpProjectFormsWidgetData, [_data]);

  if (!data) {
    return <></>;
  }

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.SingleFormWithImageAtTheRight:
      return (
        <SingleFormWithImageAtRight
          data={data}
          projectId={projectId}
          disabled={disabled}
          widget={widget}
        />
      );
    case CpWidgetVariantType.SingleFormWithImageAtTheLeft:
      return (
        <SingleFormWithImageAtLeft
          data={data}
          projectId={projectId}
          disabled={disabled}
          widget={widget}
        />
      );

    case CpWidgetVariantType.SingleFormWithImageAtTheCenter:
      return (
        <SingleFormWithImageAtCenter
          data={data}
          projectId={projectId}
          disabled={disabled}
          widget={widget}
        />
      );

    case CpWidgetVariantType.MultiFormWithImageAtTheLeft:
      return (
        <MultiFormWithImageAtTheLeft
          data={data}
          projectId={projectId}
          disabled={disabled}
          widget={widget}
        />
      );

    case CpWidgetVariantType.MultiFormWithAllRoundBorder:
      return (
        <MultiFormWithAllRoundBorder
          data={data}
          projectId={projectId}
          disabled={disabled}
          widget={widget}
        />
      );

    case CpWidgetVariantType.MultiFormWithBottomBorder:
      return (
        <MultiFormWithBottomBorder
          data={data}
          disabled={disabled}
          widget={widget}
          projectId={projectId}
        />
      );
    default:
      return <></>;
  }
};
